<div>
  <h4>Transferência de Pontos</h4>
  <input type="date" id="date" #date>
  <button (click)="pay(date.value)">Salvar</button>
</div>
